import React from "react";
import "../InvoiceModal.css";
import Logo from "../../../../../../../assets/images/hajex_logo.png";
import { useTranslation } from "react-i18next";

const Footer = ({ data, type = "Show" }) => {
  const { t } = useTranslation("admin");
  let customDecoration = { textDecoration: "underline" };
  let customPosition = { position: "relative", top: "-8px" };
  let customPadding = { paddingTop: "5px" };

  if (type === "Show") {
    customDecoration = {};
    customPosition = {};
    customPadding = {};
  }

  return (
    <>
      <div className="invmodal__invoicedashed_line"></div>
      <div
        className="invmodal__bottom_titletxt"
        style={{ justifyContent: "center" }}
      >
        <b>
          {t("payments.taxSlipFooter")}
        </b>
      </div>
    </>
  );
};

export default Footer;
